var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 305.616 305.616",
    style: {
      enableBackground: "new 0 0 305.616 305.616"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.818,260.333c-24.459,0-0.397-24.818-0.397-24.818l62.359-68.532 c6.065-6.663,17.769-16.78,24.612-11.199c6.842,5.58,15.98,16.888,22.344,23.268l12.896,12.907c6.913,6.119,12.232,0,12.232,0 l13.195-12.999c6.418-6.326,15.61-17.362,22.463-22.496c6.853-5.134,18.509,4.629,24.557,11.308l61.994,68.5 c24.47,24.062,0.397,24.062,0.397,24.062H24.818z M35.403,203.951c-6.065,6.668-14.925,18.264-20.913,24.998 C7.729,236.548,0,242.318,0,229.009L0.294,95.311c0.022-9.013-0.228-26.2,5.929-23.116c2.29,1.148,5.423,3.535,9.676,7.794 l50.464,41.288c6.973,5.706,16.801,12.689,20.016,17.34c2.029,2.932,2.959,6.342,0.022,9.29L35.403,203.951z M171.423,156.452 c-6.967,5.716-14.539,13.826-18.406,13.837c-3.867,0.005-11.58-7.919-18.58-13.598L24.634,67.621 c-7-5.673-19.058-17.1-13.065-20.163c4.329-2.214,11.895-2.176,11.895-2.176h258.029c23.23,0,11.417,11.471,11.417,11.471 L171.423,156.452z M291.11,228.949c-5.999-6.728-14.865-18.33-20.924-24.998l-50.969-56.05c-2.953-2.948-2.029-6.358,0-9.29 c3.214-4.65,13.048-11.629,20.027-17.334l37.845-30.959c6.973-5.706,16.143-15.039,22.295-18.123 c6.152-3.084,5.885,14.109,5.907,23.116l0.326,133.698C305.621,242.318,297.881,236.548,291.11,228.949z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/Letter.3aa8d2f5821452716d155b23d0d8721b.svg";
export { ForwardRef as ReactComponent };